var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    stroke: "#535151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27302 13.5686C7.27302 15.8748 3.9588 18.9692 3.9588 18.9692C3.9588 18.9692 0.644531 15.8748 0.644531 13.5686C0.644531 11.7382 2.12837 10.2544 3.9588 10.2544C5.78918 10.2544 7.27302 11.7382 7.27302 13.5686Z",
    stroke: "current",
    strokeWidth: 1.1,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5888 13.5679C4.5888 13.9193 4.30396 14.2041 3.9526 14.2041C3.60125 14.2041 3.31641 13.9193 3.31641 13.5679C3.31641 13.2166 3.60125 12.9317 3.9526 12.9317C4.30396 12.9317 4.5888 13.2166 4.5888 13.5679Z",
    stroke: "current",
    strokeWidth: 1.1,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.359 4.11546C21.359 6.42168 18.0447 9.51611 18.0447 9.51611C18.0447 9.51611 14.7305 6.42168 14.7305 4.11546C14.7305 2.28507 16.2143 0.801235 18.0447 0.801235C19.8751 0.801235 21.359 2.28507 21.359 4.11546Z",
    stroke: "current",
    strokeWidth: 1.1,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6747 4.11478C18.6747 4.46614 18.3899 4.75098 18.0385 4.75098C17.6872 4.75098 17.4023 4.46614 17.4023 4.11478C17.4023 3.76343 17.6872 3.47859 18.0385 3.47859C18.3899 3.47859 18.6747 3.76343 18.6747 4.11478Z",
    stroke: "current",
    strokeWidth: 1.1,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53516 18.9692H15.6786C16.9839 18.9692 18.0421 17.9111 18.0421 16.6058V16.6058C18.0421 15.3005 16.9839 14.2424 15.6786 14.2424H12.0737C10.7685 14.2424 9.71033 13.1842 9.71033 11.879C9.71033 10.5737 10.7685 9.51551 12.0737 9.51551H15.4638",
    stroke: "current",
    strokeWidth: 1.1,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.ded06b32c5c2f72bddb51d2939950e07.svg";
export { ForwardRef as ReactComponent };